import Axios from '@/http'

export default {
  page(controller, params) {
    return new Promise((resolve, reject) => {
      Axios.post('deviceTrail/' + controller + '/page', params, {
        isJSON: true
      }).then((res) => {
        resolve(res)
      })
    })
  },

  /* 里程统计 */
  mileageCal(params) {
    return new Promise((resolve, reject) => {
      Axios.post('/deviceTrail/mileageCal', params).then((res) => {
        resolve(res)
      })
    })
  },
  /* 备注保存 */
  saveRemark(params) {
    return new Promise((resolve, reject) => {
      Axios.post('/deviceTrail/saveRemark', params, { isJSON: true }).then(
        (res) => {
          resolve(res)
        }
      )
    })
  }
}
